// patch:gowdham:zoho-oauth
import { ZohoButton } from "metabase/auth/components/ZohoButton";
import {
  PLUGIN_AUTH_PROVIDERS,
  PLUGIN_IS_PASSWORD_USER,
} from "metabase/plugins";
import MetabaseSettings from "metabase/utils/settings";

PLUGIN_AUTH_PROVIDERS.providers.push((providers) => {
  const zohoProvider = {
    name: "zoho",
    Button: ZohoButton,
  };

  return MetabaseSettings.isZohoAuthEnabled()
    ? [zohoProvider, ...providers]
    : providers;
});

PLUGIN_IS_PASSWORD_USER.push((user) => user.sso_source !== "zoho");
